import React from 'react';

import Box from '../../components/Box/Box';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';
import { TDivider } from './types';

type TDividerBase = {
  as?: keyof JSX.IntrinsicElements;
  kind?: string;
} & TDivider;

const DividerBase = ({ as = 'div', kind, center, left, right, dashed, dotted, children, ...rest }: TDividerBase) => {
  const conditionalProps = filterConditionalKeyValues({
    modifiers: [
      kind,
      left && !center && 'orientation-left',
      right && !center && 'orientation-right',
      dashed && 'variant-dashed',
      dotted && 'variant-dotted',
    ],
  });
  const role = as === 'hr' ? undefined : 'separator';

  return (
    <Box {...rest} {...conditionalProps} as={as} role={role} name="Divider">
      {children}
    </Box>
  );
};

export default DividerBase;
